import {IConfigSchema,} from '@/containers/FdcMilanoVolunteers/resources/config-schema';
import {COLORS} from '@/utils/constants';
import {ISubmissionProps} from '@/containers/FdcMilanoVolunteers/resources/submission';
import {getIndicators} from './calculations';

export const configSchema = (submissions: ISubmissionProps[]): IConfigSchema => ({
    title: 'II. PARTECIPAZIONE DEI VOLONTARI ALLE ATTIVITA’ FORMATIVE',
    tooltip: 'Il visual mostra il livello di partecipazione dei volontari alle attività formative, in particolare propone il confronto fra la quota di volontari che ha effettivamente partecipato ad almeno 2 moduli formativi su 3 e il corrispondente valore atteso (100% dei volontari).',
    type: 'column',
    categories: ['Percentuale di volontari che ha seguito almeno 2 su 3 moduli formativi'],
    series: [
        {
            color: COLORS.blue,
            name: 'Valore Effetivo',
            data: [getIndicators(submissions)]
        },
        {
            color: COLORS.red,
            name: 'Valore Atteso',
            data: [100]
        },
    ],
});